import { IDatabaseImageControl } from "Controls/Interfaces";
import { Control } from "Controls/Control";
import { DisplayModes } from "Enums";
import { ControlTemplate } from "Controls/Entities";

/**
 * ## Database Image
 *
 * Control for showing images stored in the database.
 *
 * @since 4.0.0
 * @example
 * ```JavaScript
 * // Access the instance of an DatabaseImageControl with ControlID 1337
 * // In script:
 * @@ctr:1337@@
 *
 * // On page:
 * $dms(1337)
 * ```
 */
export class DatabaseImageControl extends Control implements IDatabaseImageControl {
    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-databaseimage";

    /**
     * @hidden
     */
    protected defaultEditorElement = "<div />";

    /**
     * Internal method for setElement.
     * @param element JQueryElement for initialization.
     * @hidden
     */
    protected setElementInternal(element: JQuery): void {}

    /**
     * Unused.
     * @hidden
     */
    public getValue(): string {
        return null;
    }

    /**
     * Unused.
     * @param value
     * @hidden
     */
    public setValue(value: string) {}

    /**
     * Gets template for showing tooltips.
     * @param bindingField Bound field in the datarow.
     * @hidden
     */
    protected getTooltipTemplate(bindingField?: string): string {
        return "";
    }

    /**
     * Internal method for getting the template.
     * @param displayMode DisplayMode for control.
     * @param bindingField Field which the control is bound to.
     * @hidden
     */
    protected getTemplateInternal(displayMode: DisplayModes, bindingField?: string): ControlTemplate {
        let controlTemplate = new ControlTemplate();
        let element: JQuery;
        if (
            displayMode == DisplayModes.Display ||
            (displayMode == DisplayModes.Edit && !this.controlDefinition.OnEditEditable) ||
            (displayMode == DisplayModes.Add && !this.controlDefinition.OnAddEditable)
        ) {
            element = $(`<img src="data:#= get('${bindingField}ContentType') #;base64,#= get('${bindingField}') #"/>`);
            if (this.controlDefinition.Width) {
                element.css("max-width", this.controlDefinition.Width);
            }
            if (this.controlDefinition.Height) {
                element.css("max-height", this.controlDefinition.Height);
            }
        } else {
            element = $("<div/>");
        }

        controlTemplate.template = element[0].outerHTML;
        controlTemplate.element = element;
        controlTemplate.editable = false;
        return controlTemplate;
    }

    /**
     * Dispose the control and release all resources.
     * @since 4.0.0
     */
    public dispose(): void {
        super.dispose();
    }
}
